import React, {Component} from 'react';
import '../../style.css';
import {Button, Form, Input, message, Modal, PageHeader, Space, Tag, Tooltip, Typography} from "antd";
import {fetchPost, fetchPostFile} from "../../static/util/fetch";
import FileViewer from 'react-file-viewer';
const { Paragraph } = Typography;

class RDProjectManage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyId:this.props.companyId,
            companyName:this.props.companyName,
            organizationData:[
                {
                    para1:'',
                    para2:'',
                    para3:'',
                    para4:'',
                    time:'',
                    companyName:'',
                }
            ],
            para1:'',
            para2:'',
            para3:'',
            para4:'',
            time:'',
            status:false,
            fileStream:'',
            preview_visible:false,
            fileStream_upload:'',
            fileField:[],
            upload_visible:false,
            uploadFile_visible:false,
            checkStatus:false,
        }
        this.hideModal = this.hideModal.bind(this);
    }
    componentDidMount() {
        fetchPost(global.constants.getRDProjectManageQ1, {companyId:this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            organizationData:res.data,
                            para1:res.data.para1,
                            para2:res.data.para2,
                            para3:res.data.para3,
                            para4:res.data.para4,
                            time:res.data.time,
                            companyName:res.data.companyName,
                            status:true
                        }))
                    }
                    else{
                        message.info("该材料未填写数据，请填写").then()
                        this.setState(()=>({
                            organizationData:[],
                            status:false
                        }))
                    }
                }
            )
    }
    edit(){
        fetchPost(global.constants.getRDProjectManageQ1, {companyId:this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            para1:res.data.para1,
                            para2:res.data.para2,
                            para3:res.data.para3,
                            para4:res.data.para4,
                            time:res.data.time,
                            companyName:res.data.companyName,
                            status:false,
                        }))
                    }
                    else{
                        console.log("获取失败")
                    }
                }
            )
    }
    submit(){
        if(this.state.time === ''||this.state.para1 === ''||this.state.para2 === ''||this.state.para3 === ''||
            this.state.para4 === ''){
            message.info("请检查信息是否填写完整").then()
        }else{
            let params={
                companyId:this.state.companyId,
                companyName:this.state.companyName,
                para1: this.state.para1,
                para2: this.state.para2,
                para3: this.state.para3,
                para4: this.state.para4,
                time:this.state.time
            }
            fetchPost(global.constants.updateRDProjectManage,params)
                .then(
                    res => {
                        if(res.code === 200) {
                            message.success("添加成功").then()
                            fetchPost(global.constants.getRDProjectManageQ1, {companyId:this.state.companyId})
                                .then(
                                    res => {
                                        if(res.code === 200) {
                                            this.setState(()=>({
                                                organizationData:res.data,
                                                para1:res.data.para1,
                                                para2:res.data.para2,
                                                para3:res.data.para3,
                                                para4:res.data.para4,
                                                time:res.data.time,
                                                companyName:res.data.companyName,
                                                status:true,
                                            }))
                                        }
                                    }
                                )
                        }
                    }
                )
        }
    }
    para1Change(e){
        const value = e.target.value
        this.setState(()=>({
            para1:value
        }))
    }
    para2Change(e){
        const value = e.target.value
        this.setState(()=>({
            para2:value
        }))
    }
    para3Change(e){
        const value = e.target.value
        this.setState(()=>({
            para3:value
        }))
    }
    para4Change(e){
        const value = e.target.value
        this.setState(()=>({
            para4:value
        }))
    }
    timeChange(e){
        const value = e.target.value
        this.setState(()=>({
            time:value
        }))
    }
    handleExportClick(){
        let params = {
            companyId:this.state.companyId
        }
        fetchPost(global.constants.exportRDProjectManageQ1,params)
            .then(
                res => {
                    if(res.code === 200) {
                        message.success("已在云端生成，请下载").then()
                    }
                    else{
                        message.info("生成失败，请先添加数据").then()
                    }
                }
            )
    }
    download(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'',
            url: '/create/'+this.state.companyName+'/研发项目管理制度.doc',
            fileName: '研发项目管理制度.doc'
        }
        fetchPostFile(global.constants.downloadFile,params)
            .then(
                res=>{
                    res.blob().then(
                        blob=>{
                            let blobUrl = window.URL.createObjectURL(blob);
                            let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                            let filename = '研发项目管理制度.doc';//设置文件名称
                            aElement.href = blobUrl;//设置a标签路径
                            aElement.download = filename;
                            aElement.click();
                            window.URL.revokeObjectURL(blobUrl);
                        }
                    )
                }
            )
    }
    hideModal(){
        this.setState(()=>({
            preview_visible:false,
            upload_visible:false,
        }))
    }
    handlePreviewClick(){
        let params={
            companyId:this.state.companyId,
            fileName:'研发项目管理制度.doc'
        }
        fetchPost(global.constants.checkFileProcess, params)
            .then(
                res=> {
                    if (res.code === 200) {
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'',
                            url: '/create/'+this.state.companyName+'/研发项目管理制度.pdf',
                            fileName: '研发项目管理制度.pdf'
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream:blobUrl,
                                                preview_visible:true,
                                            }))
                                        })
                                }
                            )
                    }else{
                        message.info("云端不存在该文件，请先生成！").then()
                    }
                }
            )
    }
    hideModalTwo(){
        this.setState(()=>({
            uploadFile_visible:false,
        }))
    }
    handleUploadClick(){
        this.setState(()=>({
            upload_visible:true,
        }))
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'研发项目管理制度',
            url:'',
        }
        fetchPost(global.constants.checkFile, params)
            .then(
                res => {
                    if(res.code === 200){
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'研发项目管理制度',
                            url: '',
                            fileName: ''
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream_upload:blobUrl,
                                                checkStatus:true
                                            }))
                                        })
                                }
                            )
                    }
                    else{
                        this.setState(()=>({
                            fileStream_upload:'',
                            checkStatus:false,
                        }))
                    }
                })
    }
    fileInput(){
        this.setState(()=>({
            fileField:document.querySelector("input[type='file'][name='file']"),
            uploadFile_visible:true,
        }))
    }
    uploadFile(){
        const formdata = new FormData();
        formdata.append('file', this.state.fileField.files[0]);
        formdata.append('companyId',this.state.companyId);
        formdata.append('projectId',0);
        formdata.append('productId',0);
        formdata.append('patentId',0);
        formdata.append('otherId',0);
        formdata.append('remark','研发项目管理制度');
        if (!(/pdf$/i.test(this.state.fileField.files[0].name))) {
            alert("只允许上传pdf格式的文件")
        } else{
            fetch(global.constants.uploadFile, {
                method: 'POST',
                body: formdata,
                mode: 'cors',
                credentials: 'include',
            })
                .then(res => res.json())
                .then(
                    res => {
                        if(res.code === 200){
                            message.success("上传成功").then();
                            let params = {
                                companyId:this.state.companyId,
                                projectId:0,
                                productId:0,
                                patentId:0,
                                otherId:0,
                                remark:'研发项目管理制度',
                                url: '',
                                fileName: ''
                            }
                            fetchPostFile(global.constants.previewFile,params)
                                .then(
                                    res=>{
                                        res.blob().then(
                                            blob=> {
                                                let blobUrl = window.URL.createObjectURL(blob);
                                                this.setState(()=>({
                                                    fileStream_upload:blobUrl,
                                                    uploadFile_visible:false,
                                                    checkStatus:true,
                                                }))
                                            })
                                    }
                                )
                        }
                    })
        }
    }
    deleteUpload(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'研发项目管理制度',
            url: '',
        }
        fetchPost(global.constants.deleteFile,params)
            .then(
                res=>{
                    if(res.code === 200){
                        message.success("删除成功").then()
                        this.setState(()=>({
                            checkStatus:false,
                        }))
                    }
                }
            )
    }
    render() {
        const Anchor = props => {
            return (
                <a {...props}>{props.children}</a>
            );
        };
        return (
            <div>
                <Anchor id="downloadDiv" style={{display: 'none'}}/>
                <div className="content-page-header">
                    <PageHeader
                        ghost={false}
                        title="研发项目管理制度"
                        subTitle='可编辑生成或上传，只允许上传50M以内的pdf格式的文件'
                        extra={[
                            <Button type="primary"  onClick={this.handleUploadClick.bind(this)}>上传</Button>,
                            <Button
                                onClick={this.handleExportClick.bind(this)}>生成</Button>,
                            <Tooltip title="预览生成的文件">
                                <Button
                                    type="primary"
                                    onClick={this.handlePreviewClick.bind(this)}
                                >预览</Button>
                            </Tooltip>,
                        ]}
                    >
                    </PageHeader>
                </div>
                <div>
                    <Paragraph>
                        <pre>注：若两种方式的文件均存在，文件合成时系统自动选取上传的文件。</pre>
                    </Paragraph>
                </div>
                <div className="content-frame-wordStyle">
                    <div className="content-form-wordStyle">
                        <Space direction="vertical" >
                            <Typography>
                                <Paragraph className="word">
                                    <Paragraph className="word-title">研发项目管理制度</Paragraph>
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    为使公司研发创新工作运营更有效率，节约时间和成本，特指定此申请流程。
                                </Paragraph>
                                <Paragraph className="textStyle-bold">
                                    一、研发项目的制定
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    公司年研发总费用预算相对固定，在保证销售后产品的技术支持基础上，选择更有利的项目进行。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    项目的发起：
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    1.销售和生产人员在市场或实际工作中发现好的机会，考虑对公司的发展帮助和公司技术的可行性，
                                    提出申请；按照市场或工作需求，研发创新工作由研发部牵头，会同
                                    {
                                        this.state.status === false?
                                            <Input
                                                placeholder={'请填写部门'}
                                                defaultValue={this.state.organizationData.para1}
                                                className="input_style"
                                                onChange={this.para1Change.bind(this)}
                                            />:
                                            this.state.organizationData.para1
                                    }
                                    等提出申请报告。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    2.公司客户提出产品和技术创新需求，公司参考公司能力和客户要求后审查项目可行性。
                                </Paragraph>
                                <Paragraph className="textStyle-bold">
                                    二、研发项目的立项审批
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    1.按照市场、实际工作需要和客户要求，由研发部提出立项申请，交由公司总经理审批，通过后交生产部和技术质量组论证。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    2.研发部，从技术、价值、可行性角度评价项目可行性，要求3天提出意见。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    3.
                                    {
                                        this.state.status === false?
                                            <Input
                                                placeholder={'请填写部门'}
                                                defaultValue={this.state.organizationData.para2}
                                                className="input_style"
                                                onChange={this.para2Change.bind(this)}
                                            />:
                                            this.state.organizationData.para2
                                    }
                                    意见如果可行，则需在5天内作出项目大致预算及所需时间估算。同时财务部门参考研发费用余额提出意见。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    4.由销售，财务，研发部门负责人及公司总经理讨论后，综合考虑市场，技术和财力等条件，作出项目进行与否的决定。这个流程在5天内完成。
                                </Paragraph>
                                <Paragraph className="textStyle-bold">
                                    三、项目论证
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    由
                                    {
                                        this.state.status === false?
                                            <Input
                                                placeholder={'请填写部门'}
                                                defaultValue={this.state.organizationData.para3}
                                                className="input_style"
                                                onChange={this.para3Change.bind(this)}
                                            />:
                                            this.state.organizationData.para3
                                    }
                                    负责，对前期预算下的方案进行详细论证，一般在7天内完成，并提交总经理最终确定立项与否。
                                </Paragraph>
                                <Paragraph className="textStyle-bold">
                                    四、项目进行
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    1.项目确立后，研发部需要按照实际列出大致预算及进程计划，财务部门需要配合统筹好资金；
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    2.按照项目要求，物资采购部需要作好后勤配合，销售部门随时查找更新市场情报。
                                </Paragraph>
                                <Paragraph className="textStyle-bold">
                                    五、项目审核验收
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    1.项目末期，公司内部由
                                    {
                                        this.state.status === false?
                                            <Input
                                                placeholder={'请填写部门'}
                                                defaultValue={this.state.organizationData.para4}
                                                className="input_style"
                                                onChange={this.para4Change.bind(this)}
                                            />:
                                            this.state.organizationData.para4
                                    }
                                    人员和管理人员共同对产品进行验收，并提出各自意见；
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    2. 研发部、生产部根据多方意见进行必要的整改后，提交公司进行正式验收；
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    3.成果由销售部人员有针对性的推荐给潜在用户，或由合作客户试用，并听取市场各方面意见，并进行改进或定型；
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    4.研发成果以档案形式由公司保存，同时看必要性，由公司进行专利申请。
                                </Paragraph>
                                <div style={{float:'right',marginRight:'10%'}}>
                                    <Paragraph className="textStyle">
                                        {this.state.companyName}
                                    </Paragraph>
                                    <Paragraph className="textStyle">
                                        {
                                            this.state.status === false?
                                                <Input
                                                    placeholder={'请填写文件时间'}
                                                    defaultValue={this.state.organizationData.time}
                                                    className="input_style"
                                                    onChange={this.timeChange.bind(this)}
                                                />:
                                                this.state.organizationData.time
                                        }
                                    </Paragraph>
                                </div>
                            </Typography>
                            <div>
                                <Button type="primary" className="submit-edit-button" onClick={this.submit.bind(this)}>提交</Button>
                                <Button
                                    disabled={!this.state.status}
                                    type="primary" className="submit-edit-button" onClick={this.edit.bind(this)}>编辑</Button>
                            </div>
                        </Space>
                        <Modal
                            visible={this.state.preview_visible}
                            title={'预览'}
                            onCancel={this.hideModal}
                            destroyOnClose
                            width={'50%'}
                            footer={[
                                <Button key="back" onClick={this.hideModal}>
                                    取消
                                </Button>,
                                <Button key="back"  type="primary" onClick={this.download.bind(this)}>
                                    下载
                                </Button>,
                            ]}
                        >
                            <FileViewer fileType='pdf'
                                        filePath={this.state.fileStream}
                                        onError={this.onError}
                            />
                        </Modal>
                        <Modal
                            visible={this.state.upload_visible}
                            title={'上传附件'}
                            onCancel={this.hideModal.bind(this)}
                            destroyOnClose
                            footer={[
                                <Button key="back" onClick={this.hideModal.bind(this)}>
                                    取消
                                </Button>,
                                <Button key="submit" type="primary" onClick={this.hideModal.bind(this)}>
                                    完成
                                </Button>,
                            ]}
                        >
                            <div>
                                该公司的研发项目管理制度
                                {this.state.checkStatus === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                                <Form style={{marginTop:'20px'}}>
                                    <Form.Item
                                        name='file'
                                        method="post"
                                        enctype="multipart/form-data"
                                    >
                                        <input
                                            type="file"
                                            name='file'
                                            onChange={this.fileInput.bind(this)}
                                        />
                                    </Form.Item>
                                    <Form.Item name="preview_paper">
                                        {
                                            this.state.checkStatus === true &&
                                            <div>
                                                <Button type={"primary"} onClick={this.deleteUpload.bind(this)}>删除</Button>
                                                <FileViewer fileType='pdf'
                                                            filePath={this.state.fileStream_upload}
                                                            onError={this.onError}
                                                />
                                            </div>
                                        }
                                    </Form.Item>
                                </Form>
                            </div>
                        </Modal>
                        <Modal
                            visible={this.state.uploadFile_visible}
                            title={'上传'}
                            onCancel={this.hideModalTwo.bind(this)}
                            destroyOnClose
                            footer={[
                                <Button key="back" onClick={this.hideModalTwo.bind(this)}>
                                    取消
                                </Button>,
                                <Button key="submit" type="primary" onClick={this.uploadFile.bind(this)}>
                                    确定
                                </Button>,
                            ]}
                        >
                            <div>确定上传该研发项目管理制度吗？</div>
                        </Modal>
                    </div>
                </div>
            </div>
        )
    }
}

export default RDProjectManage;